import React from "react";
import './Header.css'

const Header = () => {
    return (
        <>
            <div className='background-header'>
            </div>
            <h1 className='text-center text-uppercase title-style my-3'>Zestawienie danych pracowników</h1>
        </>

    )
};

export default Header